import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";

import { ReviewStepMobile } from "./ReviewStepMobile";
import { ReviewStepDesktop } from "./ReviewStepDektop";

export function ReviewStep() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile ? <ReviewStepMobile /> : <ReviewStepDesktop />;
}
